import {
  ChatSettingAction,
  ChatSettingActionTypes,
  IChatSettingState,
  ChatIconSize,
  ChatLauncherStyleType
} from './types';

export const defaultState: IChatSettingState = {
  mainColor: '',
  subColor: '',
  mainTitle: '',
  title: '',
  titleImage: '',
  iconImage: '',
  launcherImage: '',
  iconSize: ChatIconSize.LARGE,
  launcherStyleType: ChatLauncherStyleType.StyleA
};

export default function chatSettingReducers(
  state = defaultState,
  action: ChatSettingActionTypes
) {
  switch (action.type) {
    case ChatSettingAction.INIT_CHATBOT_SETTING:
      return {
        ...state,
        mainTitle: action.payload.chatSettingData.mainTitle,
        mainColor: action.payload.chatSettingData.mainColor,
        subColor: action.payload.chatSettingData.subColor,
        title: action.payload.chatSettingData.title,
        // titleImage: action.payload.chatSettingData.titleImage,
        titleImage: action.payload.chatSettingData.titleImage,
        iconImage: action.payload.chatSettingData.iconImage,
        launcherImage: action.payload.chatSettingData.launcherImage,
        launcherStyleType: action.payload.chatSettingData.launcherStyleType,
        iconSize: action.payload.chatSettingData.iconSize
      };
    default:
      return state;
  }
}
